import { Card, CardContent } from "@/core/components/ui/card";
import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { RosterTableSkeleton } from "./roster-table-skeleton";

export const PayrollRosterLoadingState = () => (
  <Stack
    gap="md"
    align="stretch"
    fullWidth
    className="mx-auto h-full min-h-0 max-w-[1680px] p-6 lg:p-8"
    aria-busy="true"
  >
    <span className="sr-only">Loading payroll roster</span>
    <Stack gap="xs" fullWidth className="shrink-0">
      <Stack
        direction="row"
        align="center"
        justify="between"
        gap="md"
        fullWidth
      >
        <Stack direction="row" align="center" gap="sm">
          <Skeleton className="h-8 w-44" />
          <Skeleton className="h-6 w-8 rounded-full" />
          <Skeleton className="h-6 w-20 rounded-full" />
        </Stack>
        <Stack direction="row" align="center" gap="sm">
          <Skeleton className="h-10 w-36 rounded-full" />
          <Skeleton className="size-10 rounded-full" />
        </Stack>
      </Stack>
      <Skeleton className="h-4 w-72 max-w-full" />
    </Stack>

    <Stack direction="row" align="center" gap="sm" className="flex-wrap">
      <Skeleton className="h-9 w-[19rem] max-w-full" />
      <Skeleton className="h-9 w-20 rounded-full" />
      <Skeleton className="h-9 w-24 rounded-full" />
      <Skeleton className="h-9 w-24 rounded-full" />
      <Skeleton className="h-9 w-28 rounded-full" />
    </Stack>

    <Card className="flex min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden">
      <CardContent className="flex min-h-0 flex-1 flex-col p-0">
        <RosterTableSkeleton />
      </CardContent>
    </Card>
  </Stack>
);
